import { DWBraftEditorH5 } from '@/components/braft-editor-h5';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWBraftEditorH5.displayName, DWBraftEditorH5);

export default DWBraftEditorH5;

export { DWBraftEditorH5 };
